
import React from 'react';
import Layout from '@/components/Layout';

const CheckoutSuccessPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Payment Successful</h1>
        <p className="mt-4">Thank you for your purchase!</p>
      </div>
    </Layout>
  );
};

export default CheckoutSuccessPage;
